import {
  CloseOutlined,
  EditOutlined,
  EyeOutlined,
  LockOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import { Button, Modal } from "antd";
import { FC } from "react";
import "./index.css";

interface ProjectPhasePermissionModalProps {
  open: boolean;
  phaseLabel: string;
  editable: boolean;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ProjectPhasePermissionModal: FC<ProjectPhasePermissionModalProps> = ({
  open,
  phaseLabel,
  editable,
  loading,
  onCancel,
  onConfirm,
}) => {
  const stateClass = editable ? "open" : "closed";
  const impactText = editable
    ? "所有项目成员均可编辑该阶段的任务节点和画布布局"
    : "项目成员仍可查看，但不能修改节点、批注或画布布局";

  return (
    <Modal
      maskClosable={false}
      keyboard={false}
      centered
      className="projectPhasePermissionModal"
      closable={false}
      destroyOnClose
      footer={null}
      onCancel={onCancel}
      open={open}
      title={null}
      width={520}
    >
      <div className="projectPhasePermissionModal__shell">
        <header
          className={`projectPhasePermissionModal__state projectPhasePermissionModal__state--${stateClass}`}
          data-testid="phase-permission-state"
        >
          <div className="projectPhasePermissionModal__stateIcon">
            {editable ? <UnlockOutlined /> : <LockOutlined />}
          </div>
          <div className="projectPhasePermissionModal__heading">
            <span>阶段权限设置</span>
            <h2>{editable ? "开启阶段编辑权限" : "关闭阶段编辑权限"}</h2>
          </div>
          <Button
            aria-label="关闭阶段权限弹窗"
            className="projectPhasePermissionModal__close"
            disabled={loading}
            icon={<CloseOutlined />}
            onClick={onCancel}
            title="关闭"
          />
        </header>

        <div className="projectPhasePermissionModal__body">
          <section className="projectPhasePermissionModal__phase">
            <div>
              <span>当前阶段</span>
              <strong>{phaseLabel}</strong>
            </div>
            <span
              className={`projectPhasePermissionModal__result projectPhasePermissionModal__result--${stateClass}`}
            >
              {editable ? "将开放编辑" : "将设为只读"}
            </span>
          </section>

          <section className="projectPhasePermissionModal__impact">
            <div className="projectPhasePermissionModal__impactIcon">
              {editable ? <EditOutlined /> : <EyeOutlined />}
            </div>
            <div>
              <strong>权限生效后</strong>
              <p>{impactText}</p>
            </div>
          </section>

          <div className="projectPhasePermissionModal__scope">
            <span>影响内容</span>
            <div>
              <span>任务节点</span>
              <span>节点批注</span>
              <span>画布布局</span>
            </div>
          </div>
        </div>

        <footer className="projectPhasePermissionModal__footer">
          <Button
            className="projectPhasePermissionModal__cancel"
            disabled={loading}
            onClick={onCancel}
          >
            取消
          </Button>
          <Button
            aria-label={editable ? "确认开启" : "确认关闭"}
            className={`projectPhasePermissionModal__confirm projectPhasePermissionModal__confirm--${stateClass}`}
            disabled={loading}
            icon={editable ? <UnlockOutlined /> : <LockOutlined />}
            loading={loading}
            onClick={onConfirm}
          >
            {editable ? "确认开启" : "确认关闭"}
          </Button>
        </footer>
      </div>
    </Modal>
  );
};

export default ProjectPhasePermissionModal;
